<template>
  <div class="page-tip">
    <div class="animation-container">
      <AnimatedCircle animation="17.5;27;17.5" />
      <AnimatedCircle
        animation="27;17.5;27"
        class="circle-right"
      />
      <div class="line" />
    </div>
    <h1 class="tip-title">
      {{ t('Well, this is unexpected...') }}
    </h1>
    <span class="tip-description">
      {{ description }}
      <span>{{ t('Try to go back to the main page') }}</span>
    </span>
    <NuxtLink
      :to="localePath('/')"
      class="home-btn tac"
    >
      {{ t('To the main page') }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AnimatedCircle from '../Icons/Components/AnimatedCircle.vue';

const props = defineProps<{
  error: any
}>();

const { t } = useI18n();
const localePath = useLocalePath();

const description = computed(() => {
  return (
    `${t('Sorry, but something went wrong. Error code: ')
    + props?.error?.statusCode
    }.`
  );
});
</script>

<style lang="scss" scoped>
.page-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 41.8rem;
  height: 41.8rem;

  .animation-container {
    position: relative;
    width: 16rem;
    height: 10rem;

    .circle-right {
      position: absolute;
      right: 0;
      top: 1rem;
    }

    .line {
      position: absolute;
      width: 11.5rem;
      height: 0.5rem;
      background: linear-gradient(101.99deg, var(--accent-primary) -3.52%, #3eb0d3 89.43%);
      border-radius: 5rem;
      left: 2.6rem;
      bottom: 0;
    }
  }

  .tip-title {
    margin-top: 6rem;
    font-weight: 600;
    font-size: 2.8rem;
    line-height: 3.8rem;
    color: var(--surfaces-on-surface);
  }

  .tip-description {
    margin-top: 0.8rem;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 3.2rem;
    color: rgba(229, 237, 255, 0.8);
    max-width: 41.8rem;
    text-align: center;
  }

  .home-btn {
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: var(--surfaces-low-container);
    border: 0.1rem solid var(--accent-secondary);
    border-radius: 1.2rem;
    padding: 1.5rem 8.95rem;
    color: var(--accent-secondary);
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 1.9rem;
  }
}

@media screen and (max-width: 435px) {
  .page-tip {
    width: 34.7rem;
    height: 36rem;

    .tip-img {
      width: 32.3rem;
      height: 21.6rem;
    }

    .tip-title {
      font-size: 2rem;
      line-height: 2.7rem;
    }

    .tip-description {
      font-size: 1.4rem;
      line-height: 2.6rem;
    }

    .home-btn {
      padding: 1.5rem 2.95rem;
    }
  }
}
</style>
